import type { IClock } from '@talbenmoshe/trip-os-react-model';

/** The browser's wall clock. */
export class SystemClock implements IClock {
  now(): Date {
    return new Date();
  }
}
